import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { getModuleListAction, createModuleListAction, updateModuleAction, deleteModuleAction, createScaleAction, updateScaleAction, deleteScaleAction, roomListAction, createRoomAction, updateRoomAction, deleteRoomAction, createResourceAction, updateResourceAction, deleteResourceAction } from "../../../../../store/actions";
import SquareButton from "../../../../../../../../ui/SquareButton";
import AddIcon from '@material-ui/icons/Add';
import { TextField, InputBase } from "@material-ui/core";
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import UndoOutlinedIcon from '@material-ui/icons/UndoOutlined';
import ScaleEditGrid from "./ScaleEditGrid";

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        paddingBottom: '24px',
        // height: '58px',

      "& h5": {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '18px',
        color: '#000000',
        margin: '0',
      },

      "& p": {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        color: '#000000',
        display: 'inline-block',
        margin: '0',
        padding: '4px 0 0 20px',
      }
    },
    nameDot: {
        display: 'inline-block',
        width: '5px',
        height: '5px', 
        marginRight: '10px',
        borderRadius: '50%',
    },
    header__elem: {
        width: '50%',

    },
    header__elem_right: {
        width: '50%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

    },
    summary: {
        backgroundColor: '#F2F2F2',
        flexDirection: 'row-reverse',
        padding: '0',
        "& .MuiExpansionPanelSummary-root.Mui-expanded": {
            minHeight: 'inherit'
        },
        "& .MuiExpansionPanelSummary-expandIcon.Mui-expanded": {
            transform: 'rotate(90deg)'
        },
        "& .MuiExpansionPanelSummary-content": {
            margin: '0',
        }
        
    },
    inputBase: {
        padding: '0 20px'
    },
    heading: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '18px',
        color: '#00334E',
        display: 'flex',
        alignItems: 'center',
      },
    content: {
        boxSizing: 'border-box',
        // backgroundColor: '#ffffff',
        width: '100%'
    },
    panelName: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '18px',
        color: '#000000',
        margin: '0',
    },
  }));
  


const SkillViewInfrastructure = (props) => {
    const {content, header, header__elem, header__elem_right, nameDot,
         text, summary, heading, inputBase,
         panelName  } = useStyles();

    const {roomList, getRoomList, id} = props;

    
    useEffect(() => { 
        getRoomList(id);
    }, [id]);


  return (
      <div>
            <div className={header}>
                <div className={header__elem}>
                    <h5>Помещения и ресурсы</h5>
                </div>
            </div>

            <div className={content}>
                <div>
                    {roomList.map((room, index) => {
                        return  <ExpansionPanel key={room.info.id}>
                                    <ExpansionPanelSummary
                                    expandIcon={<ArrowRightIcon />}
                                    aria-controls="panel1a-content"
                                    className={summary}
                                    id="panel1a-header"
                                    >
                                    <Typography className={heading}>
                                        {room.data.name}
                                    </Typography>

                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails>
                                        <ScaleEditGrid
                                            roomId={room.info.id}
                                            resources={room.resources} />
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                    })}
                    </div>
            </div>
      </div>
  );
};

const mapStateToProps = state => ({
    roomList: state.skill.roomList,
});

const mapDispatchToProps = dispatch => ({
    getRoomList: (id) => dispatch(roomListAction(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SkillViewInfrastructure);

